import {Injectable} from '@angular/core';
import {BrukerId, BrukerModell, BrukerRessursClient, OppdaterBrukerSpesifikasjonV2, Tidssone} from "../ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {defer, Observable, shareReplay} from "rxjs";
import {BrukerkontekstAdministrasjon} from "felles-ng2/tjenester/BrukerkontekstAdministrasjon";

const debug = initDebugger('BrukerDatatjeneste');

@Injectable() //tilgjengeliggjøres via DatalagerModul
export class BrukerDatatjeneste {

    /** Observable som gjør xhr kall ved første subscription og returnerer responsen fra denne ved alle påfølgende subscriptions */
    private readonly cachedeTidssoner = defer(() => this.brukerRessurs.hentTilgjengeligeTidssoner().somObservable())
      // cache xhr responsen og del den med alle påfølgende subscriptions
      .pipe(shareReplay(1));

    constructor(private brukerRessurs: BrukerRessursClient, private brukerkontekstAdministrasjon: BrukerkontekstAdministrasjon) {
    }

    tilgjengeligeTidssoner(): Observable<Tidssone[]> {
        return this.cachedeTidssoner;
    }

    async oppdaterNavnOgAvatar(id: BrukerId, spesifikasjon: OppdaterBrukerSpesifikasjonV2): Promise<BrukerModell> {
        const oppdatertBruker = await this.brukerRessurs.oppdaterV2(id, spesifikasjon).somPromise();
        this.brukerkontekstAdministrasjon.relastBruker(); //slik at de som trenger blir informert om at bruker har blitt oppdatert
        return oppdatertBruker;
    }

    //hjelpemetoder

}
